theme.footerSection = (function(){
  function footer(){
    // Disable accordion functionality - keep footer sections expanded on mobile
    const footerWidgets = document.querySelectorAll('.footer__widget');
    const footerWidgetInners = document.querySelectorAll('.footer__widget_inner');
    
    // Ensure all footer sections are always visible
    footerWidgets.forEach(function(widget) {
      widget.classList.remove('active');
    });
    
    footerWidgetInners.forEach(function(inner) {
      inner.style.display = 'block';
    });
    
    // Handle window resize to maintain expanded state
    window.addEventListener('resize', function () {
      footerWidgetInners.forEach(function(inner) {
        inner.style.display = 'block';
      });
      footerWidgets.forEach(function(widget) {
        widget.classList.remove('active');
      });
    });
  }
  return footer;
})();